import React from "react";

function isCabinetNode(node) {
  const category = String(
    node?.category || node?.definition?.category || ""
  ).toLowerCase();

  return category.includes("cabinet.box") || category.includes("cabinet");
}

export default function CabinetQuickActionsPanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
}) {
  const node = selectedNode || resolvedNode;

  if (!node || !isCabinetNode(resolvedNode || node)) {
    return null;
  }

  const transform = node.transform || {
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
  };

  function patchTransform(nextTransform) {
    onChangeNode?.({
      id: node.id,
      transform: nextTransform,
    });
  }

  function move(dx, dz) {
    patchTransform({
      ...transform,
      position: {
        ...transform.position,
        x: Number(transform.position?.x || 0) + dx,
        z: Number(transform.position?.z || 0) + dz,
      },
    });
  }

  function rotate(delta) {
    patchTransform({
      ...transform,
      rotation: {
        ...transform.rotation,
        y: Number(transform.rotation?.y || 0) + delta,
      },
    });
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Quick actions</div>
        <div className="text-xs text-slate-500">
          Brzo slaganje kuhinje i elemenata.
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => move(-600, 0)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          ← Move left
        </button>

        <button
          type="button"
          onClick={() => move(600, 0)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Move right →
        </button>

        <button
          type="button"
          onClick={() => move(0, -600)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          ↑ Move back
        </button>

        <button
          type="button"
          onClick={() => move(0, 600)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          ↓ Move front
        </button>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => rotate(-90)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Rotate -90°
        </button>

        <button
          type="button"
          onClick={() => rotate(90)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Rotate +90°
        </button>
      </div>
    </div>
  );
}